/**
 * @see https://advantech-curation.visualstudio.com/Marketplace/_wiki/wikis/Marketplace.wiki/329/Categories
 */

enum EnumCategoryType {
  CATEGORY = 1,
  COLLECTION = 2,
}

enum EnumProductFlag {
  NEW = 1,
  HOT = 2,
  SUITE = 3,
}

// [GET] Categories

interface ICategoryMenu {
  code: string;
  type: EnumCategoryType;
  subCategories: ICategoryMenu[];
  products: ICategoryMenuProduct[];
}

interface ICategoryMenuProduct {
  name: string;
  description: string;
  flag: EnumProductFlag | null;
  alias: string;
}

// [GET] Category

interface ICategoryCollection {
  code: string;
  products: ICategoryProduct[];
}

interface ICategoryProduct {
  name: string;
  icon: string;
  supplier: string;
  tags: string[];
  alias: string;
}

// [GET] Home

interface IHomeCategory {
  code: string;
  products: IHomeProduct[];
}

interface IHomeProduct {
  name: string;
  icon: string;
  description: string;
  tags: string[];
  alias: string;
}

export type {
  ICategoryCollection,
  ICategoryMenu,
  ICategoryMenuProduct,
  ICategoryProduct,
  IHomeCategory,
  IHomeProduct,
};

export { EnumCategoryType, EnumProductFlag };
